import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      onlinePayments: {
         panel: {
            integration: {
               actions: {
                  cancel: 'Anuluj',
                  createConfiguration: {
                     buttonLabel: 'Połącz',
                     failureMessage: 'Nie udało się nawiązać połączenia z PayU. {{errorCode}}',
                     successMessage: 'Integracja z Twoim kontem PayU powiodła się.',
                  },
               },
               form: {
                  fields: {
                     clientId: {
                        label: 'Protokół OAuth (client_id)',
                     },
                     clientSecret: {
                        label: 'Protokół OAuth (client_secret)',
                     },
                     posId: {
                        label: 'Id punktu płatności (pos_id)',
                     },
                     secondKey: {
                        label: 'Drugi klucz (MD5)',
                     },
                     termsOfService: {
                        chooseFile: 'Wybierz plik',
                        choosePdfFile: 'Wybierz plik z rozszerzeniem .pdf',
                        label: 'Dokument regulaminu',
                     },
                  },
               },
               integrationWithPayu: 'Integracja z PayU',
               intro: {
                  buttonLabel: 'Mam już konto w PayU',
               },
               onlinePaymentsTermsOfService: 'Regulamin obsługi transakcji płatniczych',
               termsOfServiceDisclaimer: 'Regulamin ten jest wymagany do poprawnego działania integracji z PayU.',
            },
            providerDetails: {
               actions: {
                  deleteIntegration: 'Usuń integację z PayU',
                  editTermsOfServiceFile: 'Edytuj załącznik regulaminu',
               },
               generalInformation: {
                  header: 'Informacje ogólne',
                  integrationStatus: {
                     label: 'Status integracji',
                     status: {
                        active: 'Aktywna',
                        inactive: 'Wystąpił problem z komunikacją - {{errorMessage}}',
                     },
                  },
               },
               integrationData: {
                  clientId: {
                     label: 'Protokół OAuth (client_id)',
                  },
                  clientSecret: {
                     label: 'Protokół OAuth (client_secret)',
                  },
                  header: 'Dane integracyjne',
                  posId: {
                     label: 'Id punktu płatności (pos_id)',
                  },
                  secondKey: {
                     label: 'Drugi klucz (MD5)',
                  },
               },
               removeIntegrationModal: {
                  actions: {
                     removeConfiguration: {
                        buttonLabel: 'Usuń integrację',
                        failureMessage: 'Nie udało się usunąć integracji z PayU. Spróbuj ponownie później.',
                        successMessage: 'Usunięto integrację z PayU.',
                     },
                  },
                  content:
                     'Czy na pewno chcesz usunąć integrację z Twoim kontem PayU? Spowoduje to wyłączenie płatności online dla skonfigurowanych usług recepcyjnych.',
                  title: 'Usuwasz integrację z PayU',
               },
               termsOfService: {
                  header: 'Regulamin obsługi transakcji płatniczych',
               },
               updateTermsOfServiceDocumentModal: {
                  actions: {
                     saveDocument: {
                        buttonLabel: 'Zapisz',
                        failureMessage: 'Nie udało się zaktualizować załącznika regulaminu. Spróbuj ponownie później.',
                        successMessage: 'Zaktualizowano załącznik regulaminu.',
                     },
                  },
                  title: 'Edytuj załącznik regulaminu',
               },
            },
         },
         shared: {
            components: {},
            fetchError: 'Nie udało się pobrać danych. Spróbuj ponownie później.',
         },
         tabName: 'Płatności online',
      },
   },
};

export const onlinePaymentsTranslationKeys = createScopedTranslationKeys(translations.pl, 'onlinePayments');
export const onlinePaymentsPanelTranslationKeys = onlinePaymentsTranslationKeys.panel;
export const onlinePaymentsSharedTranslationKeys = onlinePaymentsTranslationKeys.shared;
export const onlinePaymentsSharedComponentsTranslationKeys = onlinePaymentsTranslationKeys.shared.components;
export const onlinePaymentsProviderDetailsTranslationKeys = onlinePaymentsTranslationKeys.panel.providerDetails;
export const onlinePaymentsIntegrationTranslationKeys = onlinePaymentsTranslationKeys.panel.integration;
